<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-select
                label="Turno"
                :options="form.turno"
                text-field="nome"
                value-field="id"
                show-default-option
                v-model="model.atendimento.turnoId"
                :validations="validations.turno"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Local de atendimento"
                :options="form.localAtendimento"
                text-field="descricao"
                value-field="id"
                show-default-option
                v-model="model.atendimento.localAtendimentoId"
                :validations="validations.localAtendimento"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Tipo de atendimento"
                :options="form.tipoAtendimento"
                text-field="descricao"
                value-field="id"
                show-default-option
                v-model="model.atendimento.tipoAtendimentoId"
                :validations="validations.tipoAtendimento"
                :disabled="model.exportacao"
            />
        </rkm-col>

        <rkm-col cols="6">
            <rkm-form-select
                label="Tipo de consulta"
                :options="tipoConsulta"
                text-field="descricao"
                value-field="id"
                show-default-option
                v-model="model.atendimento.tipoConsultaId"
                :validations="validations.tipoConsulta"
                :disabled="model.atendimento.tipoAtendimentoId == enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO || model.exportacao"
            />
        </rkm-col>

        <rkm-col>
            <rkm-form-checkbox :disabled="model.exportacao"> Necessidades especiais </rkm-form-checkbox>
        </rkm-col>

        <rkm-col>
            <rkm-form-checkbox :disabled="isDisabled" v-model='model.atendimento.gestante'> Gestante </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import tipoConsulta from '@/enums/atencao-basica/atendimento-odontologico/tipoConsulta'

export default {
    computed: {
        isDisabled() {
            return this.model.cidadao.sexoId == this.enums.sexo.MASCULINO
        },
        validations() {
            return {
                turno: {
                    required: true
                },
                localAtendimento: {
                    required: true
                },
                tipoAtendimento: {
                    required: true
                },
                tipoConsulta: {
                    required: this.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.CONSULTA_AGENDADA
                },
            }
        },
        tipoConsulta() {
            if(this.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ATENDIMENTO_DE_URGENCIA) {
                return this.form.tipoConsulta.filter(tipo => {
                    return tipo.id != this.enums.tipoConsulta.CONSULTA_RETORNO
                })
            }
            return this.form.tipoConsulta
        }
    },
    data: () => ({
        enums: {
            sexo,
            tipoAtendimento,
            tipoConsulta
        }
    }),
    watch: {
        'model.atendimento.tipoAtendimentoId': function() {
            if(this.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO) {
                this.model.atendimento.tipoConsultaId = null
            }

            if(this.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ATENDIMENTO_DE_URGENCIA
                && this.model.atendimento.tipoConsultaId == this.enums.tipoConsulta.CONSULTA_RETORNO
            ) {
                this.model.atendimento.tipoConsultaId = null
            }
        }
    },
    props: {
        model: { type: Object, required: false },
        form: { type: Object, required: false }
    }
};
</script>
